import React from 'react';
import { Link } from 'react-router-dom';

import bnr1 from '../images/banner/bnr1.jpg';
import bnr3 from '../images/lines.png';
import  heroBanner  from '../images/background/EMS_9287.jpg';
import { useLanguage } from '../i18n/LanguageContext';

export function CareerCounselingPage() {
	const { t } = useLanguage();
	// advisors data
	const advisors = [
		//lcontreras@unicaribe.edu.do ctapia@unicaribe.edu.do
		// { name: 'Gary Cabrera', position: 'Vicerrector', email: 'gcabrera@unicaribe.edu.do' },
		{ 
			name: 'Clara Tapia', 
			position: 'Vicerrectora',
			email: '' 
		},
		{ 
			name: 'Lourdes Contreras', 
			position: 'Director', 
			email: '' 
		},
];

	// activities and events
	const activities = [
		{
			type: 'Recurrente',
			date: 'Tercer jueves de cada mes',
			title: 'Asesoría y planificación de gestión del empleo',
			description: 'A cargo del equipo de Gestores Humanos de la Escuela de Psicología.',
			icono: 'ti-calendar'
		},
		{
			type: 'Workshop',
			fecha: '29-10-2022',
			titulo: 'Estrategias para la búsqueda de empleo y entrevistas laborales',
			descripcion: 'Workshop especializado en técnicas de búsqueda de empleo y preparación para entrevistas.',
			icono: 'ti-briefcase'
		},
		{
			type: 'Conferencia',
			date: '13-10-2022',
			title: 'Empleabilidad',
			description: 'A cargo de la Gerente Senior de Reclutamiento y Selección del Scotiabank.',
			icono: 'ti-microphone'
		},
		{
			type: 'Charla - Taller',
			date: '12-05-2022',
			title: 'Inserción Laboral y Búsqueda Efectiva de Empleo',
			description: 'A cargo del Director de la Escuela de Psicología, Ariel Báez.',
			icono: 'ti-comments'
		}
	];

	return (
		<div className="page-wraper">
			<div className="page-content bg-white">
				{/* Hero Section */}
				<div className="dez-bnr-inr overlay-black-middle" style={{ backgroundImage: "url(" + heroBanner + ")" }}>
					<div className="container">
						<div className="dez-bnr-inr-entry">
					<h1 className="text-white" style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '20px' }}>
							{t('career.title')}
						</h1>
							
						</div>
					</div>
				</div>

				<div className="content-block">
					{/* Sección Introductoria */}
					<div
						className="section-full content-inner overlay-white-middle"
						style={{
							paddingTop: '80px',
							paddingBottom: '0px',
							background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #f0f4f8 100%)',
							position: 'relative',
							overflow: 'hidden'
						}}
					>
						{/* Patrón decorativo de fondo */}
						<div
							style={{
								position: 'absolute',
								top: 0,
								left: 0,
								right: 0,
								bottom: 0,
								backgroundImage: `url(${bnr3})`,
								opacity: 0.02,
								backgroundSize: 'cover',
								backgroundPosition: 'center',
								pointerEvents: 'none'
							}}
						></div>

						<div className="container" style={{ position: 'relative', zIndex: 1 }}>
							<div className="row align-items-center m-b50">
								<div className="col-lg-6 col-md-12 m-b30">
									<div className="section-head">
										<h2
											className="m-b20"
											style={{
												fontSize: '2.8rem',
												fontWeight: 'bold',
												color: '#232323',
												letterSpacing: '-0.02em'
											}}
										>
											{t('career.sectionTitle')}
										</h2>
										<div className="dez-separator-outer m-b30">
											<div className="dez-separator bg-primary" style={{ width: '80px', height: '4px' }}></div>
										</div>
										<p
											className="font-18 m-b25"
											style={{
												lineHeight: '1.8',
												color: '#4a4a4a'
											}}
										>
										{t('career.desc1')}
									</p>
									<p
										className="font-18"
										style={{
											lineHeight: '1.8',
											color: '#4a4a4a'
										}}
									>
										{t('career.desc2')}
										</p>
									</div>
								</div>

								<div className="col-lg-6 col-md-12">
									<div className="row">
										<div className="col-md-6 m-b20">
											<div
												className="p-a30 bg-white radius-sm h-100"
												style={{
													boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
													borderRadius: '16px',
													borderTop: '4px solid #009247',
													transition: 'all 0.3s',
													textAlign: 'center'
												}}
												onMouseEnter={(e) => {
													e.currentTarget.style.transform = 'translateY(-5px)';
													e.currentTarget.style.boxShadow = '0 12px 35px rgba(0,146,71,0.15)';
												}}
												onMouseLeave={(e) => {
													e.currentTarget.style.transform = 'translateY(0)';
													e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.1)';
												}}
											>
												<div
													style={{
														width: '70px',
														height: '70px',
														margin: '0 auto 20px',
														borderRadius: '50%',
														background: 'linear-gradient(135deg, #00924715 0%, #00924708 100%)',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center'
													}}
												>
													<i className="ti-user" style={{ fontSize: '35px', color: '#009247' }}></i>
												</div>
												<h5 className="m-b10" style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#232323' }}>
													{advisors.length} {t('career.advisors')}
												</h5>
												<p className="m-b0 font-14" style={{ color: '#4a4a4a', lineHeight: '1.6' }}>
													{t('career.specializedProfessionals')}
												</p>
											</div>
										</div>
										<div className="col-md-6 m-b20">
											<div
												className="p-a30 bg-white radius-sm h-100"
												style={{
													boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
													borderRadius: '16px',
													borderTop: '4px solid #fdba18',
													transition: 'all 0.3s',
													textAlign: 'center'
												}}
												onMouseEnter={(e) => {
													e.currentTarget.style.transform = 'translateY(-5px)';
													e.currentTarget.style.boxShadow = '0 12px 35px rgba(253,186,24,0.25)';
												}}
												onMouseLeave={(e) => {
													e.currentTarget.style.transform = 'translateY(0)';
													e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.1)';
												}}
											>
												<div
													style={{
														width: '70px',
														height: '70px',
														margin: '0 auto 20px',
														borderRadius: '50%',
														background: 'linear-gradient(135deg, rgba(253,186,24,0.15) 0%, rgba(253,186,24,0.08) 100%)',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center'
													}}
												>
													<i className="ti-calendar" style={{ fontSize: '35px', color: '#fdba18' }}></i>
												</div>
												<h5 className="m-b10" style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#232323' }}>
													{t('career.flexibleHours')}
												</h5>
												<p className="m-b0 font-14" style={{ color: '#4a4a4a', lineHeight: '1.6' }}>
													{t('career.flexibleHoursDesc')}
												</p>
											</div>
										</div>
										<div className="col-md-6 m-b20">
											<div
												className="p-a30 bg-white radius-sm h-100"
												style={{
													boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
													borderRadius: '16px',
													borderTop: '4px solid #009247',
													transition: 'all 0.3s',
													textAlign: 'center'
												}}
												onMouseEnter={(e) => {
													e.currentTarget.style.transform = 'translateY(-5px)';
													e.currentTarget.style.boxShadow = '0 12px 35px rgba(0,146,71,0.15)';
												}}
												onMouseLeave={(e) => {
													e.currentTarget.style.transform = 'translateY(0)';
													e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.1)';
												}}
											>
												<div
													style={{
														width: '70px',
														height: '70px',
														margin: '0 auto 20px',
														borderRadius: '50%',
														background: 'linear-gradient(135deg, #00924715 0%, #00924708 100%)',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center'
													}}
												>
													<i className="ti-briefcase" style={{ fontSize: '35px', color: '#009247' }}></i>
												</div>
												<h5 className="m-b10" style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#232323' }}>
													{t('career.specializedGuidance')}
												</h5>
												<p className="m-b0 font-14" style={{ color: '#4a4a4a', lineHeight: '1.6' }}>
													{t('career.specializedGuidanceDesc')}
												</p>
											</div>
										</div>
										<div className="col-md-6 m-b20">
											<div
												className="p-a30 bg-white radius-sm h-100"
												style={{
													boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
													borderRadius: '16px',
													borderTop: '4px solid #009247',
													transition: 'all 0.3s',
													textAlign: 'center'
												}}
												onMouseEnter={(e) => {
													e.currentTarget.style.transform = 'translateY(-5px)';
													e.currentTarget.style.boxShadow = '0 12px 35px rgba(0,146,71,0.15)';
												}}
												onMouseLeave={(e) => {
													e.currentTarget.style.transform = 'translateY(0)';
													e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.1)';
												}}
											>
												<div
													style={{
														width: '70px',
														height: '70px',
														margin: '0 auto 20px',
														borderRadius: '50%',
														background: 'linear-gradient(135deg, #00924715 0%, #00924708 100%)',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center'
													}}
												>
													<i className="ti-headphone-alt" style={{ fontSize: '35px', color: '#009247' }}></i>
												</div>
												<h5 className="m-b10" style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#232323' }}>
													{t('career.personalAttention')}
												</h5>
												<p className="m-b0 font-14" style={{ color: '#4a4a4a', lineHeight: '1.6' }}>
													{t('career.personalAttentionDesc')}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* Sección de Asesores */}
					<div
						className="section-full content-inner-2 overlay-white-middle"
						style={{
							// paddingTop: '80px',
							paddingBottom: '80px',
							background: '#ffffff',
							position: 'relative'
						}}
					>
						{/* Patrón decorativo sutil */}
						<div
							style={{
								position: 'absolute',
								top: 0,
								left: 0,
								right: 0,
								bottom: 0,
								backgroundImage: `url(${bnr3})`,
								opacity: 0.03,
								backgroundSize: 'cover',
								backgroundPosition: 'center',
								pointerEvents: 'none'
							}}
						></div>

						<div className="container" style={{ position: 'relative', zIndex: 1 }}>
							<div className="section-head text-center ">
								<h2
									className="m-b10"
									style={{
										fontSize: '2.5rem',
										fontWeight: 'bold',
										color: '#232323',
										letterSpacing: '-0.02em'
									}}
								>
									{t('career.ourAdvisors')}
								</h2>
								<div className="dez-separator-outer m-b20">
									<div className="dez-separator" style={{ width: '80px', height: '4px', margin: '0 auto', background: 'linear-gradient(90deg, #009247 0%, #009247 40%, #fdba18 60%, #009247 100%)' }}></div>
								</div>
								<p
									className="m-t20 font-18"
									style={{
										maxWidth: '700px',
										margin: '20px auto 0',
										lineHeight: '1.8',
										color: '#4a4a4a'
									}}
								>
									{t('career.ourAdvisorsDesc')}
								</p>
							</div>

							<div className="row m-t50">
								{advisors.map((advisor, index) => {
									// Destacar la primera tarjeta con color amarillo
									const isFirst = index === 0;
									const borderColor = isFirst ? '#fdba18' : '#009247';
									const iconBg = isFirst
										? 'linear-gradient(135deg, #fdba18 0%, #e6a816 100%)'
										: 'linear-gradient(135deg, #009247 0%, #007a39 100%)';
									const hoverShadow = isFirst
										? '0 15px 40px rgba(253,186,24,0.3)'
										: '0 15px 40px rgba(0,146,71,0.2)';

									return (
										<div key={index} className="col-lg-4 col-md-6 col-sm-12 m-b30">
											<div
												className="p-a30 bg-white radius-sm h-100"
												style={{
													boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
													borderRadius: '16px',
													borderTop: `4px solid ${borderColor}`,
													transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
													cursor: 'pointer',
													position: 'relative',
													overflow: 'hidden'
												}}
												onMouseEnter={(e) => {
													e.currentTarget.style.transform = 'translateY(-10px)';
													e.currentTarget.style.boxShadow = hoverShadow;
												}}
												onMouseLeave={(e) => {
													e.currentTarget.style.transform = 'translateY(0)';
													e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.1)';
												}}
											>
												{/* Patrón decorativo de fondo */}
												<div
													style={{
														position: 'absolute',
														top: '-20px',
														right: '-20px',
														width: '100px',
														height: '100px',
														background: 'linear-gradient(135deg, rgba(0,146,71,0.05) 0%, rgba(0,146,71,0.02) 100%)',
														borderRadius: '50%',
														zIndex: 0
													}}
												></div>

												<div style={{ position: 'relative', zIndex: 1 }}>
													{/* Avatar/Icono */}
													<div
														className="text-center m-b20"
														style={{
															width: '80px',
															height: '80px',
															margin: '0 auto 20px',
															borderRadius: '50%',
															background: iconBg,
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'center',
															boxShadow: isFirst
																? '0 5px 15px rgba(253,186,24,0.4)'
																: '0 5px 15px rgba(0,146,71,0.3)'
														}}
													>
														<i className="ti-user" style={{ fontSize: '35px', color: '#ffffff' }}></i>
													</div>

													{/* Información del asesor */}
													<div className="text-center">
														<h4
															className="m-b10"
															style={{
																fontSize: '1.3rem',
																fontWeight: 'bold',
																color: '#232323'
															}}
														>
															{advisor.name}
														</h4>
														<p
															className="m-b20"
															style={{
																fontSize: '1rem',
																color: '#009247',
																fontWeight: '600',
																textTransform: 'uppercase',
																letterSpacing: '0.5px'
															}}
														>
															{advisor.position}
														</p>
														<a
															href={`mailto:${advisor.email}`}
															className="font-14"
															style={{
																color: '#4a4a4a',
																textDecoration: 'none',
																display: 'inline-flex',
																alignItems: 'center',
																transition: 'all 0.3s'
															}}
															onMouseEnter={(e) => {
																e.target.style.color = '#009247';
															}}
															onMouseLeave={(e) => {
																e.target.style.color = '#4a4a4a';
															}}
														>
															<i className="ti-email m-r5"></i>
															{advisor.email}
														</a>
													</div>
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>

					{/* activities and events */}
					{false && <div
						className="section-full content-inner overlay-white-middle"
						style={{
							paddingTop: '80px',
							paddingBottom: '80px',
							background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #f0f4f8 100%)'
						}}
					>
						<div className="container">
							<div className="section-head text-center m-b60">
								<h2
									className="m-b10"
									style={{
										fontSize: '2.5rem',
										fontWeight: 'bold',
										color: '#232323',
										letterSpacing: '-0.02em'
									}}
								>
									Actividades y <span style={{ color: '#009247' }}>Eventos</span>
								</h2>
								<div className="dez-separator-outer m-b20">
									<div className="dez-separator bg-primary" style={{ width: '80px', height: '4px', margin: '0 auto' }}></div>
								</div>
								<p
									className="m-t20 font-18"
									style={{
										maxWidth: '700px',
										margin: '20px auto 0',
										lineHeight: '1.8',
										color: '#4a4a4a'
									}}
								>
									Participa en nuestros workshops, conferencias y actividades de desarrollo profesional.
								</p>
							</div>

							<div className="row m-t50">
								{activities.map((activity, index) => (
									<div key={index} className="col-lg-6 col-md-12 m-b30">
										<div
											className="p-a40 bg-white radius-sm h-100"
											style={{
												boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
												borderRadius: '16px',
												borderLeft: '5px solid #009247',
												transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
												cursor: 'pointer',
												position: 'relative',
												overflow: 'hidden'
											}}
											onMouseEnter={(e) => {
												e.currentTarget.style.transform = 'translateX(5px)';
												e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,146,71,0.2)';
											}}
											onMouseLeave={(e) => {
												e.currentTarget.style.transform = 'translateX(0)';
												e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.1)';
											}}
										>
											{/* Badge de tipo */}
											<div
												style={{
													display: 'inline-block',
													padding: '6px 16px',
													borderRadius: '20px',
													background: 'linear-gradient(135deg, #009247 0%, #007a39 100%)',
													color: '#ffffff',
													fontSize: '12px',
													fontWeight: '600',
													textTransform: 'uppercase',
													letterSpacing: '0.5px',
													marginBottom: '20px'
												}}
											>
												{activity.type}
											</div>

											{/* Icono */}
											<div className="m-b20" style={{ display: 'flex', alignItems: 'center' }}>
												<div
													style={{
														width: '60px',
														height: '60px',
														borderRadius: '12px',
														background: 'linear-gradient(135deg, #00924715 0%, #00924708 100%)',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														marginRight: '20px'
													}}
												>
													<i className={activity.icono} style={{ fontSize: '28px', color: '#009247' }}></i>
												</div>
												<div>
													<p
														style={{
															fontSize: '14px',
															color: '#009247',
															fontWeight: '600',
															margin: 0,
															textTransform: 'uppercase',
															letterSpacing: '0.5px'
														}}
													>
														{activity.date}
													</p>
												</div>
											</div>

											{/* Título */}
											<h4
												className="m-b15"
												style={{
													fontSize: '1.4rem',
													fontWeight: 'bold',
													color: '#232323',
													lineHeight: '1.4'
												}}
											>
												{activity.title}
											</h4>

											{/* Descripción */}
											<p
												className="m-b0 font-16"
												style={{
													lineHeight: '1.8',
													color: '#4a4a4a'
												}}
											>
												{activity.description}
											</p>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>}

					{/* Sección de Información de Contacto */}
					{false && <div
						className="section-full content-inner-2 overlay-white-middle"
						style={{
							paddingTop: '80px',
							paddingBottom: '80px',
							// background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
							background: '#00004c',
							position: 'relative',
							overflow: 'hidden'
						}}
					>
						{/* Patrón decorativo */}
						<div
							style={{
								position: 'absolute',
								top: '-100px',
								right: '-100px',
								width: '300px',
								height: '300px',
								background: 'rgba(255,255,255,0.05)',
								borderRadius: '50%',
								zIndex: 0
							}}
						></div>
						<div
							style={{
								position: 'absolute',
								bottom: '-50px',
								left: '-50px',
								width: '200px',
								height: '200px',
								background: 'rgba(255,255,255,0.03)',
								borderRadius: '50%',
								zIndex: 0
							}}
						></div>

						<div className="container" style={{ position: 'relative', zIndex: 1, }}>
							<div className="row align-items-center">
								<div className="col-lg-8 col-md-12 m-auto text-center text-white">
									<div className="icon-xl m-b30" style={{ fontSize: '70px' }}>
										<i className="ti-headphone-alt"></i>
									</div>
									<h2
										className="m-b20 text-white"
										style={{
											fontSize: '2.5rem',
											fontWeight: 'bold'
										}}
									>
										¿Necesitas más información?
									</h2>
									<p
										className="m-b40 font-18"
										style={{
											maxWidth: '700px',
											margin: '0 auto 40px',
											lineHeight: '1.8',
											opacity: 0.95
										}}
									>
										Contáctanos para obtener más detalles sobre nuestros servicios de asesoría laboral y horarios disponibles.
									</p>
									<div className="row text-left">
										<div className="col-md-6 m-b20">
											<div style={{ display: 'flex', alignItems: 'flex-start' }}>
												<div
													style={{
														width: '50px',
														height: '50px',
														borderRadius: '12px',
														background: 'rgba(255,255,255,0.15)',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														marginRight: '20px',
														flexShrink: 0
													}}
												>
													<i className="ti-location-pin" style={{ fontSize: '24px' }}></i>
												</div>
												<div>
													<h5 className="m-b10 text-white" style={{ fontWeight: 'bold' }}>Ubicación</h5>
													<p className="m-b0 font-16" style={{ opacity: 0.9, lineHeight: '1.6' }}>
														Autopista 30 de Mayo, Santo Domingo<br />
														11105, República Dominicana
													</p>
												</div>
											</div>
										</div>
										<div className="col-md-6 m-b20">
											<div style={{ display: 'flex', alignItems: 'flex-start' }}>
												<div
													style={{
														width: '50px',
														height: '50px',
														borderRadius: '12px',
														background: 'rgba(255,255,255,0.15)',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														marginRight: '20px',
														flexShrink: 0
													}}
												>
													<i className="ti-email" style={{ fontSize: '24px' }}></i>
												</div>
												<div>
													<h5 className="m-b10 text-white" style={{ fontWeight: 'bold' }}>Email</h5>
													<a
														href="mailto:uniempleo@unicaribe.edu.do"
														className="font-16"
														style={{ color: '#ffffff', textDecoration: 'none', opacity: 0.9 }}
														onMouseEnter={(e) => {
															e.target.style.opacity = '1';
															e.target.style.textDecoration = 'underline';
														}}
														onMouseLeave={(e) => {
															e.target.style.opacity = '0.9';
															e.target.style.textDecoration = 'none';
														}}
													>
														uniempleo@unicaribe.edu.do
													</a>
												</div>
											</div>
										</div>
										<div className="col-md-6 m-b20">
											<div style={{ display: 'flex', alignItems: 'flex-start' }}>
												<div
													style={{
														width: '50px',
														height: '50px',
														borderRadius: '12px',
														background: 'rgba(255,255,255,0.15)',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														marginRight: '20px',
														flexShrink: 0
													}}
												>
													<i className="ti-mobile" style={{ fontSize: '24px' }}></i>
												</div>
												<div>
													<h5 className="m-b10 text-white" style={{ fontWeight: 'bold' }}>Teléfono</h5>
													<p className="m-b0 font-16" style={{ opacity: 0.9, lineHeight: '1.6' }}>
														(809) 616-1616<br />
														Ext. 705
													</p>
												</div>
											</div>
										</div>
										<div className="col-md-6 m-b20">
											<div style={{ display: 'flex', alignItems: 'flex-start' }}>
												<div
													style={{
														width: '50px',
														height: '50px',
														borderRadius: '12px',
														background: 'rgba(255,255,255,0.15)',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														marginRight: '20px',
														flexShrink: 0
													}}
												>
													<i className="ti-time" style={{ fontSize: '24px' }}></i>
												</div>
												<div>
													<h5 className="m-b10 text-white" style={{ fontWeight: 'bold' }}>Horario</h5>
													<p className="m-b0 font-16" style={{ opacity: 0.9, lineHeight: '1.6' }}>
														Tercer jueves de cada mes<br />
														Asesoría y planificación
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>}
				</div>
			</div>
		</div>
	);
}